import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC, useEffect } from 'react';
import Colors from '../../utils/color';

interface ISlashCommandReminderStyleProps {
  isVisible: boolean;
}

const useStyles = makeStyles<Theme, ISlashCommandReminderStyleProps>(
  ({ spacing }) => ({
    slashCommandReminderClass: {
      width: '100%',
      height: '48px',
      backgroundColor: Colors.readBack,
      padding: spacing(1.5),
      color: Colors.white,
      overflowY: 'auto',
      display: ({ isVisible }) => (isVisible ? 'block' : 'none'),
      transition: 'all 0.3s ease',
    },
    messageContainer: {
      fontSize: '1rem',
      display: 'flex',
      height: '100%',
      flexDirection: 'row',
      columnGap: '8px',
      alignItems: 'flex-start',
      lineHeight: '30px',
    },
    boldFontClass: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
    messageClass: {
      wordBreak: 'break-all',
    },
  })
);

interface SlashCommandReminderProps {
  message: string;
  isVisible: boolean;
  timeout?: number;
  onHide?: () => void;
}

const SlashCommandReminder: FC<SlashCommandReminderProps> = ({
  message,
  isVisible,
  timeout,
  onHide,
}) => {
  const {
    slashCommandReminderClass,
    messageContainer,
    boldFontClass,
    messageClass,
  } = useStyles({ isVisible });

  if (!isVisible) {
    return null;
  }

  return (
    <div
      data-testid="slash-command-reminder"
      className={slashCommandReminderClass}
    >
      <div className={messageContainer}>
        <div className={boldFontClass}>REMINDER: </div>
        <div className={messageClass}>{message}</div>
      </div>
    </div>
  );
};

export default SlashCommandReminder;
